export const PATH_ONBOARDING = "/member/onboarding";
export const PATH_ONBOARDING_PAYER = PATH_ONBOARDING + "/payer";
export const PATH_ONBOARDING_PAYEE = PATH_ONBOARDING + "/payee";
export const PATH_ONBOARDING_TAX_PAYEE = PATH_ONBOARDING + "/tax-payee";
export const PATH_ONBOARDING_TAX_PAYER = PATH_ONBOARDING + "/tax-payer";
export const PATH_ONBOARDING_TAX_WITHHOLDINGS =
  PATH_ONBOARDING + "/tax-withholdings";
export const PATH_ONBOARDING_VERIFICAIONS_TAX =
  PATH_ONBOARDING + "/verifications/tax";
export const PATH_ONBOARDING_VERIFICAIONS_BANKING =
  PATH_ONBOARDING + "/verifications/banking";
export const PATH_ONBOARDING_CHANGE = PATH_ONBOARDING + "/change";
export const PATH_ONBOARDING_US_PERSON_INFO =
  PATH_ONBOARDING + "/us-person-info";

export const PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS =
  PATH_ONBOARDING_PAYEE + "/requirements/:requirementId/details";
